const Aux = (props:any) => props.children;

export default Aux;